export default "__VITE_ASSET__te3Z$vqA__"